module.exports = __webpack_public_path__ + "img/t12.b03c9d22.png";